import { Fragment } from 'react';
import { IconButton, Tooltip, useEventCallback } from '@mui/material';
import { createSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ActionPropsCohabitation } from 'shell/view-models/actions-props';
import { Delete, Edit, Visibility } from '@mui/icons-material';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';
import { CohabitationAuthorizations } from 'shell/authorizations/cohabitation';

export const authsObj = Object.freeze({
  read: [CohabitationAuthorizations.CohabitationQuery],
  edit: [CohabitationAuthorizations.CohabitationUpdate],
  delete: [CohabitationAuthorizations.CohabitationDelete],
});

const ActionsList = ({ cell, form }: ActionPropsCohabitation): React.ReactElement => {
  const navigate = useNavigate();

  const auths = useActionAuthorization(authsObj);

  const onDetailPress = useEventCallback(() => {
    return new Promise((resolve) => {
      navigate({
        pathname: '/convivenza/ricerca/dettaglio',
        search: `?${createSearchParams({
          ricercaNazionale: form?.isNationalResearch?.toString() || 'false',
          anprId: cell?.idANPR || '',
        })}`,
      });
      resolve(cell);
    });
  });

  const onEditPress = useEventCallback(() => {
    return new Promise((resolve) => {
      navigate({
        pathname: '/convivenza/ricerca/modifica',
        search: `?${createSearchParams({
          ricercaNazionale: form?.isNationalResearch?.toString() || 'false',
          anprId: cell?.idANPR || '',
        })}`,
      });
      resolve(cell);
    });
  });

  const onDeletePress = useEventCallback(() => {
    return new Promise((resolve) => {
      navigate({
        pathname: '/convivenza/ricerca/cancellazione',
        search: `?${createSearchParams({
          ricercaNazionale: form?.isNationalResearch?.toString() || 'false',
          anprId: cell?.idANPR || '',
        })}`,
      });
      resolve(cell);
    });
  });

  return (
    <Fragment>
      <Tooltip
        arrow
        title={auths.read ? '' : "Non si ha l'autorizzazione per accedere a questa funzionalità"}
      >
        <span>
          <IconButton
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onDetailPress();
            }}
            aria-label="Visualizza elemento"
            aria-haspopup="true"
            style={{
              padding: '4px',
            }}
            disabled={!auths.read}
          >
            <Visibility />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip
        arrow
        title={auths.edit ? '' : "Non si ha l'autorizzazione per accedere a questa funzionalità"}
      >
        <span>
          <IconButton
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onEditPress();
            }}
            aria-label="Modifica elemento"
            aria-haspopup="true"
            style={{
              padding: '4px',
            }}
            disabled={!auths.edit}
          >
            <Edit />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip
        arrow
        title={auths.delete ? '' : "Non si ha l'autorizzazione per accedere a questa funzionalità"}
      >
        <span>
          <IconButton
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onDeletePress();
            }}
            aria-label="Cancella elemento"
            aria-haspopup="true"
            color="cdmBrand"
            style={{
              padding: '4px',
            }}
            disabled={!auths.delete}
          >
            <Delete />
          </IconButton>
        </span>
      </Tooltip>
    </Fragment>
  );
};

ActionsList.displayName = 'Action list Document - residency permit page component';

export default ActionsList;
